import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { ValidatedField, ValidatedForm } from 'react-jhipster';
import { Link, useNavigate, useParams } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';

import { createEntity, getEntity, reset, updateEntity } from './estatus.reducer';

export const EstatusUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const estatusEntity = useAppSelector(state => state.estatus.entity);
  const loading = useAppSelector(state => state.estatus.loading);
  const updating = useAppSelector(state => state.estatus.updating);
  const updateSuccess = useAppSelector(state => state.estatus.updateSuccess);

  const handleClose = () => {
    navigate(`/estatus${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.mt !== undefined && typeof values.mt !== 'number') {
      values.mt = Number(values.mt);
    }
    if (values.hs !== undefined && typeof values.hs !== 'number') {
      values.hs = Number(values.hs);
    }
    if (values.hp !== undefined && typeof values.hp !== 'number') {
      values.hp = Number(values.hp);
    }
    if (values.e !== undefined && typeof values.e !== 'number') {
      values.e = Number(values.e);
    }
    if (values.dvVendedor !== undefined && typeof values.dvVendedor !== 'number') {
      values.dvVendedor = Number(values.dvVendedor);
    }
    if (values.tcVendedor !== undefined && typeof values.tcVendedor !== 'number') {
      values.tcVendedor = Number(values.tcVendedor);
    }
    if (values.ciVendedor !== undefined && typeof values.ciVendedor !== 'number') {
      values.ciVendedor = Number(values.ciVendedor);
    }
    if (values.dvClient !== undefined && typeof values.dvClient !== 'number') {
      values.dvClient = Number(values.dvClient);
    }
    if (values.tcClient !== undefined && typeof values.tcClient !== 'number') {
      values.tcClient = Number(values.tcClient);
    }
    if (values.ciClient !== undefined && typeof values.ciClient !== 'number') {
      values.ciClient = Number(values.ciClient);
    }
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.lastModifiedDate = convertDateTimeToServer(values.lastModifiedDate);

    const entity = {
      ...estatusEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: displayDefaultDateTime(),
          lastModifiedDate: displayDefaultDateTime(),
        }
      : {
          ...estatusEntity,
          createdDate: convertDateTimeFromServer(estatusEntity.createdDate),
          lastModifiedDate: convertDateTimeFromServer(estatusEntity.lastModifiedDate),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tupago1App.estatus.home.createOrEditLabel" data-cy="EstatusCreateUpdateHeading">
            Create or edit a Estatus
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew && <ValidatedField name="id" required readOnly id="estatus-id" label="ID" validate={{ required: true }} />}
              <ValidatedField
                label="Id Mensaje Cobro"
                id="estatus-idMensajeCobro"
                name="idMensajeCobro"
                data-cy="idMensajeCobro"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Cc"
                id="estatus-cc"
                name="cc"
                data-cy="cc"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField label="Mt" id="estatus-mt" name="mt" data-cy="mt" type="text" />
              <ValidatedField label="Hs" id="estatus-hs" name="hs" data-cy="hs" type="text" />
              <ValidatedField label="Hp" id="estatus-hp" name="hp" data-cy="hp" type="text" />
              <ValidatedField label="E" id="estatus-e" name="e" data-cy="e" type="text" />
              <ValidatedField
                label="Cr"
                id="estatus-cr"
                name="cr"
                data-cy="cr"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Nc Vendedor"
                id="estatus-ncVendedor"
                name="ncVendedor"
                data-cy="ncVendedor"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField label="Dv Vendedor" id="estatus-dvVendedor" name="dvVendedor" data-cy="dvVendedor" type="text" />
              <ValidatedField label="Tc Vendedor" id="estatus-tcVendedor" name="tcVendedor" data-cy="tcVendedor" type="text" />
              <ValidatedField
                label="Cb Vendedor"
                id="estatus-cbVendedor"
                name="cbVendedor"
                data-cy="cbVendedor"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField label="Ci Vendedor" id="estatus-ciVendedor" name="ciVendedor" data-cy="ciVendedor" type="text" />
              <ValidatedField
                label="Nb Vendedor"
                id="estatus-nbVendedor"
                name="nbVendedor"
                data-cy="nbVendedor"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Nc Client"
                id="estatus-ncClient"
                name="ncClient"
                data-cy="ncClient"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField label="Dv Client" id="estatus-dvClient" name="dvClient" data-cy="dvClient" type="text" />
              <ValidatedField label="Tc Client" id="estatus-tcClient" name="tcClient" data-cy="tcClient" type="text" />
              <ValidatedField
                label="Cb Client"
                id="estatus-cbClient"
                name="cbClient"
                data-cy="cbClient"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField label="Ci Client" id="estatus-ciClient" name="ciClient" data-cy="ciClient" type="text" />
              <ValidatedField
                label="Nb Client"
                id="estatus-nbClient"
                name="nbClient"
                data-cy="nbClient"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 1"
                id="estatus-extra1"
                name="extra1"
                data-cy="extra1"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 2"
                id="estatus-extra2"
                name="extra2"
                data-cy="extra2"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 3"
                id="estatus-extra3"
                name="extra3"
                data-cy="extra3"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 4"
                id="estatus-extra4"
                name="extra4"
                data-cy="extra4"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 5"
                id="estatus-extra5"
                name="extra5"
                data-cy="extra5"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 6"
                id="estatus-extra6"
                name="extra6"
                data-cy="extra6"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 7"
                id="estatus-extra7"
                name="extra7"
                data-cy="extra7"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 8"
                id="estatus-extra8"
                name="extra8"
                data-cy="extra8"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 9"
                id="estatus-extra9"
                name="extra9"
                data-cy="extra9"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Extra 10"
                id="estatus-extra10"
                name="extra10"
                data-cy="extra10"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Created By"
                id="estatus-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Created Date"
                id="estatus-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label="Last Modified By"
                id="estatus-lastModifiedBy"
                name="lastModifiedBy"
                data-cy="lastModifiedBy"
                type="text"
                validate={{
                  maxLength: { value: 50, message: 'This field cannot be longer than 50 characters.' },
                }}
              />
              <ValidatedField
                label="Last Modified Date"
                id="estatus-lastModifiedDate"
                name="lastModifiedDate"
                data-cy="lastModifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <Button as={Link as any} id="cancel-save" data-cy="entityCreateCancelButton" to="/estatus" replace variant="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button variant="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EstatusUpdate;
